import { IApp04AIChatUser } from '../types';
import { EntityService } from './EntityService';

export class App04AIChatUserService extends EntityService<IApp04AIChatUser> {
    constructor() {
        super(`/App04AIChatUsers`);
    }
}